import { createSlice } from "@reduxjs/toolkit";

import { CircleProps } from "./circles";

const initialState: CircleProps.State = {
  listOfCircles: [],
  createCircleOpen: false,
  editCircleId: "",
  createCircle_API_STATUS: "idle",
  deleteCircle_API_STATUS: "idle",
};

const slice = createSlice({
  name: "circle",
  initialState,
  reducers: {
    setListOfCircles: (state, action: CircleProps.setListOfCircles) => {
      state.listOfCircles = action.payload;
    },
    setCircle: (state, action: CircleProps.setCircle) => {
      state.listOfCircles.push(action.payload);
    },
    setupdateCircle: (state, action: CircleProps.setCircle) => {
      state.listOfCircles = state.listOfCircles.map((circle) =>
        circle.id === action.payload.id ? action.payload : circle
      );
    },
    setRemoveCircle: (state, action: CircleProps.setRemoveCircle) => {
      state.listOfCircles = state.listOfCircles.filter(
        (circle) => circle.id !== action.payload.id
      );
    },
    setCreateCircleOpen: (state, action: CircleProps.setCreateCircleOpen) => {
      const { createCircleOpen, editCircleId = "" } = action.payload;
      state.createCircleOpen = createCircleOpen;
      state.editCircleId = editCircleId;
    },

    setAddUserToCircle: (state, action: CircleProps.setAddUserToCircle) => {
      const circle = state.listOfCircles.find(
        (circle) => circle.id === action.payload.circle_id
      );
      if (circle) {
        const new_circle_user_ids = circle.circle_user_ids || [];
        new_circle_user_ids.push(action.payload.id);
        circle.circle_user_ids = new_circle_user_ids;
      }
    },
    setRemoveUserFromCircle: (
      state,
      action: CircleProps.setRemoveUserFromCircle
    ) => {
      const circle = state.listOfCircles.find(
        (circle) => circle.id === action.payload.circle_id
      );
      if (circle) {
        circle.circle_user_ids = (circle.circle_user_ids || []).filter(
          (user_id) => user_id !== action.payload.user_id
        );
      }
    },
    setCreateCircle_API_STATUS: (
      state,
      action: CircleProps.setCreateCircle_API_STATUS
    ) => {
      state.createCircle_API_STATUS = action.payload;
    },
    setDeleteCircle_API_STATUS: (
      state,
      action: CircleProps.setDeleteCircle_API_STATUS
    ) => {
      state.deleteCircle_API_STATUS = action.payload;
    },
    reset: () => initialState,
  },
});

export const circleActions = slice.actions;
export const circleReducer = slice.reducer;
